import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/shared/reducers/user-management';
import { IRecordedInterview } from 'app/shared/model/recorded-interview.model';
import { getEntities as getRecordedInterviews } from 'app/entities/recorded-interview/recorded-interview.reducer';
import { IInterview } from 'app/shared/model/interview.model';
import { InterviewsStatus } from 'app/shared/model/enumerations/interviews-status.model';
import { getEntity, updateEntity, createEntity, reset } from './interview.reducer';

export const InterviewUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const users = useAppSelector(state => state.userManagement.users);
  const recordedInterviews = useAppSelector(state => state.recordedInterview.entities);
  const interviewEntity = useAppSelector(state => state.interview.entity);
  const loading = useAppSelector(state => state.interview.loading);
  const updating = useAppSelector(state => state.interview.updating);
  const updateSuccess = useAppSelector(state => state.interview.updateSuccess);
  const interviewsStatusValues = Object.keys(InterviewsStatus);

  const handleClose = () => {
    navigate('/interview' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUsers({}));
    dispatch(getRecordedInterviews({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...interviewEntity,
      ...values,
      user: users.find(it => it.id.toString() === values.user.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          statusType: 'Scheduled',
          ...interviewEntity,
          user: interviewEntity?.user?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.interview.home.createOrEditLabel" data-cy="InterviewCreateUpdateHeading">
            <Translate contentKey="fivePlusApp.interview.home.createOrEditLabel">Create or edit a Interview</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="interview-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('fivePlusApp.interview.name')} id="interview-name" name="name" data-cy="name" type="text" />
              <ValidatedField
                label={translate('fivePlusApp.interview.interviewTime')}
                id="interview-interviewTime"
                name="interviewTime"
                data-cy="interviewTime"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.interview.duration')}
                id="interview-duration"
                name="duration"
                data-cy="duration"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.interview.statusType')}
                id="interview-statusType"
                name="statusType"
                data-cy="statusType"
                type="select"
              >
                {interviewsStatusValues.map(interviewsStatus => (
                  <option value={interviewsStatus} key={interviewsStatus}>
                    {translate('fivePlusApp.InterviewsStatus.' + interviewsStatus)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('fivePlusApp.interview.dailyCoLink')}
                id="interview-dailyCoLink"
                name="dailyCoLink"
                data-cy="dailyCoLink"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.interview.daliyCoRoom')}
                id="interview-daliyCoRoom"
                name="daliyCoRoom"
                data-cy="daliyCoRoom"
                type="text"
              />
              <ValidatedField id="interview-user" name="user" data-cy="user" label={translate('fivePlusApp.interview.user')} type="select">
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/interview" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default InterviewUpdate;
